import "./Loading.css";

export default function Loading() {
  return (
    <div
      style={{
        pointerEvents: "auto",
        opacity: 1,
        transition: "opacity 0.3s",
      }}
      className="fixed inset-0 z-[9999] flex items-center justify-center"
    >
      <img
        src="https://assets.atomicpay.net/companies/EFsTqJCtjnKMbKPgPEp8/library/S4anMyLeqUMafteHgQl7.png"
        alt="Loading..."
        className="animate-ap-fade w-16 h-16"
        style={{ filter: "drop-shadow(0 2px 16px rgba(0,0,0,0.12))" }}
      />

      <style>{`
      @keyframes ap-fade {
        0% { opacity: 0.2; }
        50% { opacity: 1; }
        100% { opacity: 0.2; }
      }
      .animate-ap-fade {
        animation: ap-fade 2s infinite cubic-bezier(0.4,0,0.2,1);
      }
    `}</style>
    </div>
  );
}
